document.addEventListener("DOMContentLoaded", () => {

  const phoneInputs = document.querySelectorAll("input[data-au-phone]");

  const validPrefixes = ["02", "03", "04", "07", "08"];

  phoneInputs.forEach((input) => {

    // Keep only digits
    input.addEventListener("input", () => {

      let value = input.value.replace(/\D/g, "");

      // Maximum Australian number length
      if (value.length > 10) {
        value = value.substring(0, 10);
      }

      input.value = value;

      validatePhone(input);

    });

    // Validate when leaving the field
    input.addEventListener("blur", () => {
      validatePhone(input);
    });

    // Final validation before submit
    input.form?.addEventListener("submit", (e) => {

      validatePhone(input);

      if (!input.checkValidity()) {
        e.preventDefault();
        input.reportValidity();
        return;
      }

      // Convert to international format
      const value = input.value.replace(/\D/g, "");

      if (value.startsWith("0")) {
        input.value = "+61" + value.substring(1);
      }

    });

  });

  function validatePhone(input) {

    const value = input.value.replace(/\D/g, "");

    // Required validation is handled by HTML
    if (value === "") {
      input.setCustomValidity("");
      return;
    }

    // Missing area code
    if (value.length === 8) {
      input.setCustomValidity(
        "Please include the area code (e.g. 07 5576 3281)."
      );
      return;
    }

    // Wrong length
    if (value.length !== 10) {
      input.setCustomValidity(
        "Australian phone numbers must contain 10 digits."
      );
      return;
    }

    // Invalid Australian prefix
    const prefix = value.substring(0, 2);

    if (!validPrefixes.includes(prefix)) {
      input.setCustomValidity(
        "Please enter a valid Australian phone number."
      );
      return;
    }

    input.setCustomValidity("");

  }

});